// LivestreamOverlayCta.js
'use strict';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import {
  FEATURE_LIVESTREAM_SNAPSHOT,
  LIVESTREAM_PAY_DURATION_SECONDS,
} from '../RemoteConfigKeys.js';

import LivestreamOverlayCta from '../component/LivestreamOverlayCta.jsx';

import getMeData from '../selector/getMeData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getUserData from '../selector/getUserData.js';
import getOperationData from '../selector/getOperationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getPublicUrlHostname from '../selector/getPublicUrlHostname.js';
import { getLiveStreamExclusivePrivatePrice } from '../selector/getLiveStreamPrice.js';
import {
  getHasStreamToken,
  getLivestreamMode,
  getIsAudioLive,
  getIsMeExclusivePrivateInviteInitiator,
} from '../selector/getLivestreamComputedData.js';
import getMeBalance from '../selector/getMeBalance.js';
import addvalue from '../action/addvalue.js';
import unlockPrivateStream from '../action/unlockPrivateStream.js';

import {
  ExclusivePrivateStatus,
  PRESET_PREVIEW,
} from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { streamId }) => {
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const username = getUserData(state, streamId, 'username');
  const balance = getMeBalance(state);
  const priceDurationMinutes =
    getRemoteConfigData(state, LIVESTREAM_PAY_DURATION_SECONDS) / 60;
  const publicUrlHostname = getPublicUrlHostname(state);
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const hasStreamToken = getHasStreamToken(state, streamId);

  const streamTokenNetworkingPath = ['fetch', 'streamToken', sessionId];
  const isFetchingStreamToken = getNetworkingData(
    state,
    streamTokenNetworkingPath,
    'isFetching'
  );
  // Hide the overlay until an expected token fetch settles, so it does not flash
  // on refresh (or prompt a duplicate charge) before we know a token is coming.
  // A fetch is only expected for a logged-in viewer on a non-preview stream — a
  // guest never fetches, so `isFetched` never flips; gating on meId keeps the
  // CTA (with its unauth quickpay footer) from being hidden indefinitely.
  const isResolvingStreamToken =
    isFetchingStreamToken ||
    (!!getMeData(state, 'id') &&
      getLiveStreamData(state, [streamId], 'status') !== PRESET_PREVIEW &&
      !getNetworkingData(state, streamTokenNetworkingPath, 'isFetched'));

  return {
    meId: getMeData(state, 'id'),
    username,
    avatarColor: getUserData(state, streamId, 'avatarColor'),
    balance,
    mode: getLivestreamMode(state, streamId),
    exclusivePrice: getLiveStreamExclusivePrivatePrice(state, streamId),
    priceDurationMinutes,
    streamTitle: getLiveStreamData(state, [streamId], 'title'),
    categories: getLiveStreamData(state, [streamId], 'categories'),
    exclusivePrivateStatus,
    sessionId,
    isLiveStreamSnapshotEnabled: getRemoteConfigData(
      state,
      FEATURE_LIVESTREAM_SNAPSHOT
    ),
    publicUrlHostname,
    isExclusivePrivatePerforming:
      exclusivePrivateStatus === ExclusivePrivateStatus.PERFORMING,
    isExclusivePrivatePreparing:
      exclusivePrivateStatus === ExclusivePrivateStatus.PREPARING,
    isMeExclusivePrivateInviteInitiator: getIsMeExclusivePrivateInviteInitiator(
      state,
      streamId
    ),
    hasStreamToken,
    isFetchingStreamToken,
    isResolvingStreamToken,
    isAsideExpanded: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isAsideExpanded'
    ),
    deviceWidth: getOperationData(state, ['device'], 'width'),
    isAudioLive: getIsAudioLive(state, streamId),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addvalue: () => dispatch(addvalue({ via: 'unlock-livestream' })),
    unlockPrivateStream: data => dispatch(unlockPrivateStream(data)),
    goBack: () => dispatch(goBack()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamOverlayCta);
